/**
 * @generated SignedSource<<780127cfb8c53612e0dbba8b34848135>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type BasicMetadata = {
  description?: string | null | undefined;
  title: string;
};
export type SeriesDetailsMetadataMutation$variables = {
  id: string;
  metadata: BasicMetadata;
};
export type SeriesDetailsMetadataMutation$data = {
  readonly updateSeriesMetadata: {
    readonly id: string;
  };
};
export type SeriesDetailsMetadataMutation = {
  response: SeriesDetailsMetadataMutation$data;
  variables: SeriesDetailsMetadataMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "metadata"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "metadata",
        "variableName": "metadata"
      }
    ],
    "concreteType": "Series",
    "kind": "LinkedField",
    "name": "updateSeriesMetadata",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SeriesDetailsMetadataMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SeriesDetailsMetadataMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "42a73c872ef260845a2d52a6ca8bbe9d",
    "id": null,
    "metadata": {},
    "name": "SeriesDetailsMetadataMutation",
    "operationKind": "mutation",
    "text": "mutation SeriesDetailsMetadataMutation(\n  $id: ID!\n  $metadata: BasicMetadata!\n) {\n  updateSeriesMetadata(id: $id, metadata: $metadata) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "7a4f80eb3c394814578a9b1ea1f71cc2";

export default node;
